"use client";

import { cn } from '@/lib/utils';
import { X } from 'lucide-react';
import Image from 'next/image';
import React, { useState } from 'react'

const Accreditation = () => {
    const [open, setOpen] = useState<string | null>(null);

    const accreditationItems = [
        {
            label: "University of Bedfordshire",
            description: "UK-accredited degrees, worldwide recognition",
            image: "/img/recognition/uob.png",
            value: "/img/recognition/uob-letter.webp",
        },
        {
            label: "Ministry of Education",
            description: "Academic Partnership Letter",
            image: "/img/recognition/moe.jpeg",
            value: "/img/recognition/course-approval-letter.webp",
        },
        {
            label: "TU Equivalency",
            description: "Letter of Equivalence",
            image: "/img/recognition/tu.png",
            value: "/img/recognition/equivalence-letter.webp",
        },
    ];

    const openedItem = accreditationItems.find(i => i.label === open);

    return (
        <>
            <section
                className={cn(
                    `xl:float-none xl:m-[6rem_auto_5rem] xl:min-h-[20rem] `,
                    `clear-both [float:inherit]`,
                    `md:m-[1.875rem_0] md:pb-[3.25rem]  md:min-h-[9.375rem]`,
                    `clear-both [float:inherit] m-[1.5625rem_0] pb-[4.0625rem] relative w-full z-[0]`,
                    `before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 
before:h-auto before:top-[12.54vw] before:bottom-0 before:left-0 
before:pointer-events-none before:w-full`
                )}
            >
                <header
                    className={`xl:w-[3.125rem] w-[2.1875rem] border-b border-b-[#272727]
 block absolute top-0 left-0 [writing-mode:vertical-lr]`}
                    style={{
                        transform: "scale(-1)",
                    }}
                >
                    <h2
                        className={`text-[0.75rem] xl:text-[1.5rem] xl:tracking-[0.125rem] 
           uppercase tracking-[0.09375rem] pb-[1.125rem] font-bold
          m-0 table-cell align-top whitespace-nowrap leading-[1]`}
                    >
                        APPROVAL LETTERS
                    </h2>
                </header>
                <div
                    className={`
                     xl:max-w-[75.625rem]
                     grid gap-y-12 md:grid-cols-3 sm:grid-cols-2 grid-cols-1
                     md:max-w-[90rem] md:p-0 md:w-[87.5%]
                     box-border m-auto
                     p-[0_2.8125rem] relative w-full
                   `}
                >
                    {accreditationItems.map((item) => {
                        return (
                            <div
                                title={item.label}
                                className={cn(`
                                    xl:basis-[20.625rem] xl:mr-[1.875rem] 
                                    xl:max-w-full
                                md:basis-[13.25rem] md:mr-[1.0625rem] inline-block 
                                basis-[14.5rem] m-[0_0_2rem] 
                                [text-decoration:none]
                                w-[14.5rem] z-[1] mr-[.5rem]
                                `)}
                                key={item.label}
                                onClick={() => setOpen(item.label)}
                            >
                                <div className="relative w-full h-[200px] flex items-center justify-center bg-white mb-[0.9375rem]">
                                    <Image
                                        src={item.image}
                                        alt={item.label}
                                        fill
                                        className="object-contain p-2 cursor-pointer"
                                    />
                                </div>
                                <span
                                    className={cn(
                                        `xl:clear-both xl:text-[.875rem] xl:leading-[1.125rem] 
        xl:m-[0_0_0.6875rem] md:mb-[0.5625rem] block clear-both text-[0.75rem] tracking-[0.125rem] leading-[1rem]
        m-[0_0_0.25rem] 
        tracking-[0.125rem] uppercase`
                                    )}
                                >
                                    <strong className="futura-medium">{item.label}</strong>
                                </span>
                                <span
                                    className={`xl:text-[1.375rem] xl:leading-[2rem] md:leading-[1.625rem] font-bold cursor-pointer
        m-0 transition-[color_0.35s_ease-out] 
        `}

                                    style={{
                                        backgroundImage:
                                            "linear-gradient(to top,transparent 0.1875rem,#A31F34 0.1875rem,#A31F34 0.3125rem,transparent 0.3125rem)",
                                    }}
                                >
                                    {item.description}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </section>
            {/* Modal for the opened item */}
            {
                openedItem && <dialog
                    className={cn(
                        `fixed inset-0 z-[9999] border-0 m-0 p-0 transition-all`,
                        `w-screen h-screen max-w-none max-h-none overflow-auto visible`,
                        `backdrop:bg-white backdrop:transition-all`
                    )}
                    open
                >
                    <div className={cn(
                        `w-full pt-0`,
                        `md:flex`,
                        `gap-x-[1.25rem] block pt-[3.25rem] relative w-full `
                    )}>

                        <button className={cn(
                            `block bg-white rounded-full p-0`,
                            `border-0 cursor-pointer text-[1.5rem] h-[2rem] absolute right-[1.25rem] top-[0.9375rem] w-[2rem] z-[3]`
                        )}
                            onClick={() => setOpen(null)}
                        >
                            <X />

                        </button>
                        <div className={cn(
                            `xl:pt-[6rem] xl:pr-[3.75rem] `,
                            `md:p-[5rem_1.5625rem_0] md:flex`,
                            `bg-[url('/svgs/dot-black.svg')] bg-repeat bg-[size:0.375rem] pt-[3.75rem] w-full`,
                            `after:block after:absolute after:top-0 after:left-0 after:h-full after:w-full 
                            after:bg-[linear-gradient(to_top,white_20%,rgba(255,255,255,0.75)_50%,rgba(255,255,255,0.5)_80%,rgba(255,255,255,0.5)_100%)]
                            `
                        )}>
                            <div className={cn(
                                `xl:p-[4.875rem_1.6875rem_0_12.125rem] xl:ml-[9.6875rem] xl:w-1/2`,
                                `md:p-[14.375rem_1.6875rem_0] md:w-[45%] `,
                                `p-[8.125rem_0.625rem_0] relative z-[1] bg-white h-full`
                            )}>
                                <div className="mb-6 max-w-full">
                                    <Image
                                        src={openedItem.value || openedItem.image}
                                        alt={openedItem.label}
                                        width={330}
                                        height={408}
                                        className="max-w-full h-auto"
                                    />
                                </div>
                            </div>

                            <div className={cn(
                                `xl:p-[4.875rem_2.9375rem_0_1.6875rem] xl:w-1/2`,
                                `md:p-[1.9375rem_1.6875rem] md:w-[55%]`,
                                `relative z-[1] bg-white p-[1.5rem_0.625rem_1.0625rem]`
                            )}>
                                <div className={cn(
                                    `md:relative text-base`,
                                    `before:w-[0.0625rem] before:h-full before:block before:absolute
                                    before:top-0 before:left-[-1.6875rem] before:bg-[#DFDFDF]
                                    `
                                )}>
                                    <div className={cn(
                                        `text-2xl leading-[2] mb-[1.5] font-bold`
                                    )}>{openedItem.label}</div>
                                    <p className={cn(
                                        `text-base leading-[1.5] mb-[1.5rem]`
                                    )}>{openedItem.description}</p>

                                </div>

                            </div>

                        </div>
                    </div>

                </dialog>
            }
        </>
    )
}

export default Accreditation